import styled from "styled-components";

export const ModalContainer = styled.div`
  padding: 2rem 2.5rem;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 2px 16px #0002;
  max-width: 420px;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #22223b;
`;

export const DetailsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  margin-bottom: 2rem;
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Label = styled.span`
  font-weight: 500;
  color: #555;
`;

export const Value = styled.span`
  color: #22223b;
  font-weight: 600;
`;

export const Select = styled.select`
  padding: 0.4rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid #eaeaea;
  font-size: 1rem;
  font-weight: 500;
  background: #f9f9f9;
`;

export const UpdateButton = styled.button`
  background: #fbbf24;
  color: #22223b;
  border: none;
  border-radius: 0.5rem;
  padding: 0.7rem 1.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 1.5rem;
  transition: background 0.2s;
  &:hover {
    background: #f59e42;
  }
`;
